import React from "react";
import {
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedService, nextStep, previousStep, setStep } from '../../redux/reducers/stepSlice';
import { RootState } from "../../store";
import UserDetails from "../userDetails/UserDetails";
import ChoosePackingService from "../choosePackingService/ChoosePackingService";
import PriceOfPackingAndLoading from "../priceOfLabourAndPacking/PriceOfPackingAndLoading";
import PriceOfPacking from "../priceOfPacking/PriceOfPacking";
import PriceOfLoad from "../priceOfLoad/PriceOfLoad";
import ChooseService from "../chooseService/ChooseService";

const LabourAndPackingCard = () => {
  const step = useSelector((state: RootState) => state.step.step);
  const selectedService = useSelector((state: RootState) => state.step.selectedService);
  const dispatch = useDispatch();

  const handleServiceSelection = (service: string) => {
    dispatch(setSelectedService(service));
    
    if (service === "pack_load") {
      dispatch(setStep(3)); 
    } else if (service === "pack_only") {
      dispatch(setStep(4)); 

    } else if (service === "load_unload") {
      dispatch(setStep(5)); 

    }
  };

  const handleBack = () => {
    dispatch(setStep(1)); 
  };
  const handleNext = () => {
    dispatch(nextStep());
  };
  return (
    <Box sx={{ width: "100%" }}>
      {/* {step === 1 && (
        <ChooseService onNext={handleNext} onBack={handleBack} step={step} serviceType="labour-and-packing"/>
      )} */}
      {step === 2 && (
        <ChoosePackingService 
          onNext={handleServiceSelection} 
          onBack={handleBack} 
          step={step} 
        />
      )}
      {step === 3 && selectedService === "pack_load" && (
        <PriceOfPackingAndLoading onNext={handleNext} onBack={handleBack} />
      )}
      {step === 4 && selectedService === "pack_only" && (
        <PriceOfPacking onNext={handleNext} onBack={handleBack} />
      )}
      {step === 5 && selectedService === "load_unload" && (
        <PriceOfLoad onNext={handleNext} onBack={handleBack} step={step} />
      )}
      {/* {step === 6 && 
        <UserDetails 
          onNext={handleNext} 
          onBack={handleBack} 
          currentValues="labour_and_packing" 
        />
      } */}
    </Box>
  );
};

export default LabourAndPackingCard;